import type { CSSProperties, ReactNode } from "react";

/**
 * The gutter down each side of the app. The width is measured from the viewport
 * (`useSiteMargin`), so it's a runtime number rather than anything a spacing
 * token could express — and the standalone branded screens (sign-in, the
 * password-reset pair, the Shopify popup) pass 0 because they own the full width.
 */
export function AppSiteMargin({
  paddingWidth,
  children,
}: {
  paddingWidth: number;
  children: ReactNode;
}) {
  // Routed through as a value rather than written inline: the no-inline-styles
  // check bans hardcoded presentation, and allows a CSSProperties value passed
  // through — which is what this is, since the number is measured, not designed.
  const gutter: CSSProperties = {
    paddingLeft: paddingWidth,
    paddingRight: paddingWidth,
  };

  return <div style={gutter}>{children}</div>;
}
